import { passwordRegex } from "../../../schemas/changePasswordSchema";
import { localStorageInstance } from "../../../utils/localStorage";

export const EMAIL_LOGIN_REGEX =
  /^[a-zA-Z0-9._%+!*-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function isEmailLoginIdentifier(input = "") {
  return EMAIL_LOGIN_REGEX.test(input);
}

export function buildLoginFormData(data = {}) {
  const formData = new FormData();
  formData.append("username", data.email || "");
  formData.append("password", data.password || "");
  return formData;
}

export function getAuthErrorMessage(error) {
  if (error?.code === "ERR_NETWORK") {
    return "An unexpected error occurred. Please try again later";
  }

  return error?.response?.data?.message || "An error occurred";
}

export function persistAuthSession({ token, refreshToken, role, userId }) {
  localStorageInstance.setItem({
    key: "token",
    value: token,
  });
  localStorageInstance.setItem({
    key: "refresh_token",
    value: refreshToken,
  });
  localStorageInstance.setItem({
    key: "role",
    value: role,
  });
  localStorageInstance.setItem({
    key: "userId",
    value: userId,
  });
}

export function persistUserAuthSession({ token, userData }) {
  persistAuthSession({
    token: token?.access_token,
    refreshToken: token?.refresh_token,
    role: userData?.role,
    userId: userData?.user_id,
  });
}

export function persistDecodedAuthData(decodedData) {
  persistAuthSession({
    token: decodedData?.access_token,
    refreshToken: decodedData?.refresh_token,
    role: decodedData?.role,
    userId: decodedData?.user_id,
  });
}

export function getLoginRedirectUrl(searchParams) {
  return (
    localStorageInstance.getItem("redirectLocation") ||
    searchParams.get("url") ||
    "/my-task?tab=mine"
  );
}

export function decodeAuthQueryData(encodedData) {
  if (!encodedData) {
    return null;
  }

  try {
    return JSON.parse(atob(encodedData));
  } catch (error) {
    return null;
  }
}

export function arePasswordRequirementsMet(password = "") {
  return Object.values(passwordRegex).every((regex) => regex.test(password));
}
